import { Component, EventEmitter, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { UserDetailsFragment } from 'generated/graphql';

import {
  CreateInvitiationFormModel
} from 'account/components/account-create/account-create.component';
import { ACCOUNT_ADDED_FROM_DIALOG } from 'app/_state/account/account-actions';
import { AccountState } from 'app/_state/account/account-state';

export interface AccountCreateDialogData {
  initialValues?: CreateInvitiationFormModel;
  hideAddAnother?: boolean;
}
@Component({
  selector: 'app-account-create-dialog',
  templateUrl: `./account-create.dialog.html`
})
export class AccountCreateDialog {
  userAdded = new EventEmitter<UserDetailsFragment>();

  static open(dialog: MatDialog, config: MatDialogConfig<AccountCreateDialogData>) {
    return dialog.open(AccountCreateDialog, config);
  }

  constructor(
    private _store: Store<AccountState>,
    public dialogRef: MatDialogRef<AccountCreateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  // Close dialog and pass along event data.
  close(event = null) {
    this.dialogRef.close(event);
  }

  emitUserAdded(event: { user: UserDetailsFragment; addAnother: boolean }) {
    this._store.dispatch(
      ACCOUNT_ADDED_FROM_DIALOG({ payload: { user: event.user } })
    );
    this.userAdded.emit(event.user);
    if (!event.addAnother) {
      this.close(event.user);
    }
  }
}
